<template>
  <div class="wing-layout">
    <div class="main-wrap">
      <div id="main-content">
        <div class="wrapper">
          <div class="table-agile-info">
            <jm-crumbs/>
            <div class="question-wrap clearfix">
              <div class="question-left">
                <div
                  class="qu-cont-layout"
                  v-loading="loading"
                  element-loading-text="拼命加载中">
                  <div class="qu-cont the-poster">
                    <div class="qu-title clearfix">
                      <div class="qu-portrait">
                        <img :src="questinAnswerData.data._SUBJECT.avatar === '' ? defaultIcon : questinAnswerData.data._SUBJECT.avatar">
                      </div>
                      <div class="qu-name-time">
                        <b>主贴</b>
                        <strong>{{ questinAnswerData.data._SUBJECT.author }}</strong>
                        <small>{{ questinAnswerData.data._SUBJECT.publishTime }}</small>
                      </div>
                    </div>
                    <div
                      class="qu-content"
                      :class="questinAnswerData.data._SUBJECT.isCurrentReply === 1 ? 'qu-highlighted': ''"
                      v-html="questinAnswerData.data._SUBJECT.content"
                    >
                      <!-- {{ questinAnswerData.data._SUBJECT.content }}-->
                    </div>
                    <div class="qu-reply qu-poster-button">
                      <el-button
                        type="primary"
                        size="mini"
                        @click="handleReply(
                          questinAnswerData.data._SUBJECT.author,
                          questinAnswerData.data._SUBJECT.tag,
                          questinAnswerData.data._SUBJECT.id
                      )">回复</el-button>
                    </div>
                  </div>
                  <div
                    class="qu-cont the-poster"
                    v-for="(item, key) in questinAnswerData.data._ANSWERS"
                    :key="key">
                    <div class="qu-title clearfix">
                      <div class="qu-portrait">
                        <img :src="item.avatar ==='' ? defaultIcon : item.avatar">
                      </div>
                      <div class="qu-name-time">
                        <strong>{{ item.author }}</strong>
                        <small>{{ item.publishTime }}</small>
                      </div>
                    </div>
                    <div class="qu-cont-tags clearfix">
                      <div class="qu-tags">
                        <span
                          class="qu-tags-inc"
                          @click="handleUpDown(item.tag, item.id, 'up')"
                          :class="item.agreeSet.type === 'up' ? 'up-active-color' : ''"
                        /><!--顶-->
                        <b>{{ item.agreeSet.number }}</b>
                        <span
                          class="qu-tags-dec"
                          @click="handleUpDown(item.tag, item.id, 'down')"
                          :class="item.agreeSet.type === 'down' ? 'down-active-color' : ''"
                        /><!--踩-->
                      </div>
                      <div class="qu-content">
                        <div
                          class="qu-text"
                          :class="item.isCurrentReply === 1 ? 'qu-highlighted': ''"
                          v-html="item.content"
                        >
                          <!--  {{ item.content }}-->
                        </div>
                        <div class="qu-reply">
                          <el-button
                            type="primary"
                            size="mini"
                            @click="handleReply(
                              item.author,
                              item.tag,
                              item.id
                          )">回复</el-button>
                          <!--<el-button type="primary" size="mini">采纳</el-button>-->
                          <el-button
                            type="danger"
                            size="mini"
                            v-if="item.userid === userInfo.userid"
                            @click="handleDel(
                              item.tag,
                              item.id
                          )">删除</el-button>
                        </div>
                        <div
                          class="qu-reply qu-reply-mt"
                          v-if="item._REPLIES">
                          <div
                            class="qu-reply-hierarchy"
                            v-for="(itemA, key) in item._REPLIES"
                            :key="key" >
                            <div class="qu-mt-top clearfix">
                              <div class="qu-mt-top1">
                                <img :src="itemA.avatar === '' ? defaultIcon : itemA.avatar">
                              </div>
                              <div class="qu-mt-top2">
                                <strong>{{ itemA.author }} <u>{{ itemA.title }}</u></strong>
                                <small>{{ itemA.publishTime }}</small>
                              </div>
                              <div class="qu-mt-top3">
                                <el-button
                                  type="primary"
                                  size="mini"
                                  @click="handleReply(
                                    itemA.author,
                                    itemA.tag,
                                    itemA.id
                                )">评论</el-button>
                                <el-button
                                  type="danger"
                                  size="mini"
                                  v-if="itemA.userid === userInfo.userid"
                                  @click="handleDel(
                                    itemA.tag,
                                    itemA.id
                                )">删除</el-button>
                              </div>
                            </div>
                            <div
                              class="qu-replay-text"
                              :class="itemA.isCurrentReply === 1 ? 'qu-highlighted' : ''"
                              v-html="itemA.content"
                            > <!--点击右侧列表数据对应显示-->
                              <!--{{ itemA.content }}-->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="qu-page">
                    <el-pagination
                      v-if="this.$route.query.currentReplyId === ''"
                      :current-page="this.questinAnswerData.current_page"
                      :page-size="this.questinAnswerData.per_page"
                      layout="total, sizes, prev, pager, next, jumper"
                      :total="this.questinAnswerData.total"
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                    />
                  </div>
                  <el-button
                    class="qu-more"
                    size="small"
                    type="primary"
                    v-if="this.$route.query.currentReplyId !== ''"
                    @click="handleMore">展开更多</el-button>
                </div>
                <div class="qu-edit clearfix">
                  <div class="qu-edit-left">
                    <!--<div class="qu-edit-button">
                      <el-button type="primary" size="mini">资讯</el-button>
                      <el-button type="primary" size="mini">院校</el-button>
                      <el-button type="primary" size="mini">服务</el-button>
                      <el-button type="primary" size="mini">问答</el-button>
                      <el-button type="primary" size="mini">百度</el-button>
                    </div>-->
                    <div
                      class="qu-replay-author"
                      v-if="replyAuthor">回复：{{ replyAuthor }}</div>
                    <div class="qu-edit-content">
                      <div
                        class="ico-default-content"
                        v-if="isIcon">
                        <img
                          v-for="(item, key) in iconData"
                          :key="key"
                          :src="item.label"
                          @click="handleImg($event)">
                      </div>
                      <div class="qu-edit-text">
                        <quill-editor
                          ref="editor"
                          v-model="quill"
                          :options="editorOption"
                          id="editorIcon"
                          @change="selectionChange"
                          @focus="editorFocus"
                        >
                          <div slot="toolbar">
                            <div class="qu-edit-top"><i
                              class="ico-default"
                              @click="handleIcon"/></div>
                          </div>
                        </quill-editor>
                        <!--<img alt="" v-for="(item, key) in temporaryImg" :src="item">-->
                        <!--<el-input
                          :rows="6"
                          type="textarea"
                          placeholder="请输入内容"
                          v-model="textarea">
                        </el-input>-->
                      </div>
                    </div>
                    <!--<div class="qu-edit-zy">
                      <el-alert
                        title="美国大学研究生就业薪酬排名美国大学研究生就业薪酬排名美国大学研究生就业薪酬排名美国大学研究生就业薪酬排名"
                      >
                      </el-alert>
                    </div>-->
                    <div class="qu-edit-hf">
                      <el-button
                        type="success"
                        size="mini"
                        @click="submitSave">发表回复</el-button>
                      <el-button
                        type="warning"
                        size="mini"
                        @click="cancelReply">取消回复</el-button>
                    </div>
                  </div>
                  <!-- <div class="qu-edit-right">
                    <ul>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li class="qu-action"><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                      <li><img src="https://www.jiemodou.net/xpcenter/avatar.php?uid=2&size=small" alt=""><span>蓝火神</span></li>
                    </ul>
                  </div> -->
                </div>
              </div>
              <!-- <div class="question-right">
                <div class="qu-list-title">资源列表</div>
                <div class="qu-list-search">
                  <el-form label-width="60px">
                    <el-form-item label="模块：">
                      <el-select placeholder="请选择" size="medium" class="jm-input135 qu-search-sel1">
                        <el-option label="芥末" value="0"></el-option>
                        <el-option label="前程日本" value="1"></el-option>
                        <el-option label="英国" value="2"></el-option>
                      </el-select>
                    </el-form-item>
                    <el-form-item>
                      <el-input placeholder="请输入内容" size="medium" class="qu-search-sel2 jm-input400">
                        <el-select slot="prepend" placeholder="请选择"  class="jm-input135">
                          <el-option label="所有" value="1"></el-option>
                          <el-option label="作者" value="2"></el-option>
                        </el-select>
                        <el-button slot="append" icon="el-icon-search"></el-button>
                      </el-input>
                    </el-form-item>
                  </el-form>
                </div>
                <div class="qu-list-content">
                  <jm-tableList :url="`index/question/student?crmid=${this.$route.params.crmid}`">
                  </jm-tableList>
                </div>
              </div>-->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import crumbs from '@/components/tool/crumbs';
import tableList from '@/components/data/tableList.vue';
import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';
import { quillEditor } from 'vue-quill-editor';
import icon from '@/dataset/icon';
import defaultTemp from '@/assets/images/timg.jpg'; // 默认头像
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      questinAnswerData: { // 存放初始化数据
        data: {
          _ANSWERS: [],
          _SUBJECT: [],
        }
      },
      cursorIndex: 1,
      loading: false,
      isIcon: false, // 显隐头像
      isMore: false,
      temporaryImg: [], // 存放表情数据
      quill: '',
      replyAuthor: '',
      tagId: '',
      tagIdAuthor: '',
      editorOption: {
        placeholder: '请输入内容',
        modules: {
          toolbar: null,
        }
      },
    };
  },
  methods: {
  /**
   * Description: 初始化数据
   * Author: yanlichen <yanlichen@tuozhongedu.com>
   */
    getAnswer(
      currentPage = this.questinAnswerData.current_page,
      pageSize = this.questinAnswerData.per_page
    ) {
      this.loading = true;
      return new Promise((resolve) => {
        this.$http._post({
          url: '/index/question/info',
          data: {
            crmid: this.$route.params.crmid,
            questionId: this.$route.params.questionId,
            currentReplyId: this.isMore === false ? this.$route.query.currentReplyId : '',
            pageSize,
            page: currentPage,
          }
        }).then(({ data }) => {
          resolve(data);
          this.questinAnswerData = data;
          this.getImgUrl();
          this.loading = false;
        });
      });
    },
    /**
     * Description:pageSize 改变时会触发
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleSizeChange(size) {
      this.getAnswer(this.questinAnswerData.currentPage, size);
    },
    /**
     * Description: currentPage 改变时会触发
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleCurrentChange(currentPage) {
      this.getAnswer(currentPage, this.questinAnswerData.per_page);
    },
    /**
     * Description: 点击表情 外层 显隐
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleIcon() {
      this.isIcon = !this.isIcon;
    },
    /**
     * Description: 点击表情 赋值
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleImg(event) {
      const quill = this.$refs.editor.quill;
      quill.focus();
      quill.insertEmbed(this.cursorIndex, 'image', event.target.currentSrc);
      quill.setSelection(++this.cursorIndex, 1);
      this.isIcon = false;
    },
    /**
     * Description: 发表文章
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    submitSave() {
      let data = {};
      Object.assign(data, { content: this.getExpUrl }, this.tagId);
      if (this.getExpUrl === '') {
        this.$message.error('回复内容不能为空');
        return false;
      }
      this.$http._post({
        url: '/index/question/reply',
        data,
      }).then(() => {
        this.$message.success('发表成功');
        this.cancelReply();
        this.getAnswer();
      });
    },
    /**
     * Description: 取消回复
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    cancelReply() {
      this.quill = '';
      this.tagId = this.tagIdAuthor;
    },
    /**
     * Description: 过滤icon数据字典 img 转表情符号
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getImgExpUrl(label) {
      const image = this.iconData.find((item) => {
        return item.label === label;
      });
      return image.icon;
    },
    /**
     * Description: 过滤icon字典数据 表情符号转img
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getExpImgUrl(icon) {
      const image = this.iconData.find((item) => {
        return item.icon === icon;
      });
      return image ? image.label : false;
    },
    /**
     * Description: 统一字符串正则
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getMatch(reg) {
      return reg.content.match(/\[.*?\]/g);
    },
    /**
     * Description: 统一替换字符串
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getTemp(getString) {
      this.getMatch(getString) && this.getMatch(getString).forEach((item) => {
        if (this.getExpImgUrl(item)) {
          getString.content = getString.content.replace(item, `<img src="${this.getExpImgUrl(item)}">`);
        }
      });
    },
    /**
     * Description: 二层嵌套 字符串替换
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getImgUrl () {
      this.questinAnswerData.data._ANSWERS.forEach((itemA) => {
        this.getTemp(itemA);
        if (itemA._REPLIES) {
          itemA._REPLIES.forEach((itemB) => {
            this.getTemp(itemB);
          });
        }
      });
    },
    /**
     * Description: 回复评论
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleReply(author, tag, id) {
      this.replyAuthor = author;
      this.tagId = {
        tag,
        id
      };
    },
    /**
     * Description: 删除评论/回复
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleDel(tag, id) {
      this.$confirm('删除此条信息, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$http._post({
          url: '/index/question/delete',
          data: {
            tag,
            id
          },
        }).then(() => {
          this.$message.success('删除成功');
          this.getAnswer();
        });
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    /**
     * Description: 顶 and 踩
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleUpDown(tag, id, type) {
      this.$http._post({
        url: '/index/question/setAgree',
        data: { tag, id, type }
      }).then(({ data }) => {
        this.questinAnswerData.data._ANSWERS.forEach((item) => {
          if (id === item.id) {
            item.agreeSet.number = data.lastNumber;
            item.agreeSet.type = data.lastType;
          }
          if (data.lastType === 'up') {
            this.$message.success('顶帖成功!');
          } else if (data.lastType === 'down') {
            this.$message.success('踩贴成功!');
          }
        });
      });
    },
    /**
     * Description: 展开更多
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    handleMore() {
      this.isMore = !this.isMore;
      if (this.isMore) {
        this.getAnswer();
        this.$route.query.currentReplyId = '';
      }
    },
    /**
     * Description: 循环遍历 回复赋值
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    temporarVariable() {
      if (this.questinAnswerData.data._SUBJECT.isCurrentReply === 1) {
        this.replyAuthor = this.questinAnswerData.data._SUBJECT.author;
        this.tagId = {
          tag: this.questinAnswerData.data._SUBJECT.tag,
          id: this.questinAnswerData.data._SUBJECT.id
        };
      } else {
        this.questinAnswerData.data._ANSWERS &&
        this.questinAnswerData.data._ANSWERS.forEach((item) => {
          if (item.isCurrentReply === 1) {
            this.replyAuthor = item.author;
            this.tagId = {
              tag: item.tag,
              id: item.id
            };
          } else {
            item._REPLIES && item._REPLIES.forEach((itemA) => {
              if (itemA.isCurrentReply === 1) {
                this.replyAuthor = itemA.author;
                this.tagId = {
                  tag: itemA.tag,
                  id: itemA.id
                };
              }
            });
          }
        });
      }
    },
    editorFocus($event) {
      this.cursorIndex = $event.getSelection().index;
    },
    selectionChange($event) {
      this.cursorIndex = $event.quill.getSelection().index;
    }
  },
  mounted() {
    /**
     * Description: 调用初始化数据
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    this.getAnswer().then((data) => {
      this.getImgUrl();
      this.replyAuthor = data.data._SUBJECT.author;
      this.tagId = {
        tag: data.data._SUBJECT.tag,
        id: data.data._SUBJECT.id
      };
      this.tagIdAuthor = this.tagId;
      this.temporarVariable();
    });
  },
  computed: {
    /**
     * Description: 表情字典数据
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    iconData () {
      return icon;
    },
    defaultIcon() {
      return defaultTemp;
    },
    /**
     * Description: img转表情符号 传给后端数据
     * Author: yanlichen <yanlichen@tuozhongedu.com>
     */
    getExpUrl() {
      return this.quill.replace(/<img src="(.*?)">/g, (match, p1) => {
        return this.getImgExpUrl(p1);
      });
    },
    ...mapGetters([
      'userInfo',
    ]),
  },
  components: {
    'jm-crumbs': crumbs, // 面包屑
    'jm-tableList': tableList,
    quillEditor
  },
};
</script>
<style scoped>
  .question-left{
    width: 60%;
    float: left;
  }
  .question-right{
    margin-left: 10px;
    width: 38%;
    float: right;
  }
  .qu-cont {
    margin-top: 10px;
    padding-bottom: 10px;
    border-bottom: 1px dashed #8d8d8d;
  }
  .qu-cont-layout {
    margin-bottom: 350px;
  }
  .qu-cont:last-of-type{
    border-bottom: none;
  }
  .qu-title {
    display: flex;
    display: -webkit-flex;
    -webkit-align-items: center;
    align-items: center;
  }
  .qu-title .qu-portrait{
    float: left;
  }
  .qu-title .qu-portrait {
    width: 50px;
    height: 50px;
    border-radius: 50%;
  }
  .qu-title .qu-portrait img {
    display: block;
    width: 100%;
    height: 100%;
    border-radius: 50%;
  }
  .qu-title .qu-name-time{
    float: left;
    margin-left: 10px;
  }
  .qu-title .qu-name-time strong {
    display: inline-block;
    max-width: 450px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #404040;
    vertical-align: middle;
  }
  .qu-title .qu-name-time small {
    margin-left: 10px;
    color: #a8a8a8;
    font-weight: 100;
    vertical-align: middle;
  }
  .qu-name-time b {
    display: inline-block;
    padding: 1px 6px;
    margin:0 5px 3px 10px;
    font-size: 10px;
    color: #fff;
    border-radius: 3px;
    background-color: #333;
    vertical-align: sub;
  }
  .qu-content {
    margin-left: 60px;
    color: #404040;
    word-wrap: break-word;
  }
  .qu-cont-tags {
    margin-top: 15px;
  }
  .qu-tags {
    background: #383838;
    width: 35px;
    height: 60px;
    float: left;
    left: 8px;
    position: relative;
    box-shadow: 0px 3px 10px #5a5e66;
  }
  .qu-tags span.qu-tags-inc{
    border-bottom: 8px solid #edf2fc;
    border-top: 0;
    position: absolute;
    top: 8px;
    left: 28%;
    display: block;
    width: 0;
    height: 0;
    border-right: 8px solid transparent;
    border-left: 8px solid transparent;
    cursor: pointer;
  }
  .qu-tags span.qu-tags-dec {
    position: absolute;
    bottom: 8px;
    left: 28%;
    display: block;
    width: 0;
    height: 0;
    border-right: 8px solid transparent;
    border-bottom: 0;
    border-left: 8px solid transparent;
    border-top: 8px solid #edf2fc;
    cursor: pointer;
  }
  .qu-tags span.up-active-color{
    border-bottom: 8px solid #409eff;
  }
  .qu-tags span.down-active-color{
    border-top: 8px solid #409eff;
  }
  .qu-tags b {
    position: absolute;
    top: 20px;
    left: 0;
    color: #fff;
    font-size: 14px;
    font-weight: 400;
    text-align: center;
    width: 100%;
  }
  .qu-content .qu-reply{
    margin-top: 15px;
  }
  .qu-content .qu-reply-mt{
    background: #f6f6f6;
    padding: 15px;
  }
  .qu-replay-author {
    margin-top: 10px;
  }
  .qu-poster-button {
    margin-top: 15px;
    margin-left: 60px;
  }
  .qu-mt-top .qu-mt-top1{
    float: left;
    width: 25px;
    height: 25px;
  }
  .qu-mt-top .qu-mt-top2{
    margin-left: 10px;
    float: left;
    line-height: 25px;
  }
  .qu-mt-top .qu-mt-top2 strong {
    display: inline-block;
    max-width: 350px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    color: #404040;
    vertical-align: middle;
  }
  .qu-mt-top .qu-mt-top2 small{
    margin-left: 10px;
    color: #a8a8a8;
    font-weight: 100;
    vertical-align: middle;
  }
  .qu-mt-top .qu-mt-top3{
    float: right;
  }
  .qu-mt-top .qu-mt-top1 img{
    width: 100%;
    height: 100%;
    border: 1px solid #8d8d8d;
    border-radius: 50%;
  }
  .qu-replay-text {
    margin-top: 6px;
    margin-left: 35px;
  }
  .qu-reply-hierarchy:first-of-type{
    padding-top: 0;
  }
  .qu-reply-hierarchy:last-of-type{
    border-bottom: none;
  }
  .qu-reply-hierarchy {
    padding-bottom: 15px;
    padding-top: 15px;
    border-bottom: 1px dashed #8d8d8d;
  }
  .qu-mt-top .qu-mt-top2 strong u{
    font-weight: 100;
  }
  .qu-page{
    clear: both;
    margin-left: 60px;
    padding-top: 15px;
  }
  .qu-edit {
    width: 51%;
    position: fixed;
    bottom: 20px;
    left: 210px;
    margin-top: 20px;
    padding: 15px;
    background: #f6f6f6;
    border: #fff solid 5px;
  }
  .qu-edit .qu-edit-left{
/*    width: 78%;
    float: left; */
  }
  .qu-edit-content {
    position: relative;
    margin-top: 10px;
    border: 1px solid #ccc;
    background-color: #fff;
  }
  .qu-edit-content .qu-edit-top {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    border-bottom: 1px solid #dcdfe6;
    padding: 6px 0;
  }
  .qu-edit-content .qu-edit-top .ico-default {
    display: inline-block;
    background: url(data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAyJpVFh0WE1MOmNvbS5hZG9iZS54bXAAAAAAADw/eHBhY2tldCBiZWdpbj0i77u/IiBpZD0iVzVNME1wQ2VoaUh6cmVTek5UY3prYzlkIj8+IDx4OnhtcG1ldGEgeG1sbnM6eD0iYWRvYmU6bnM6bWV0YS8iIHg6eG1wdGs9IkFkb2JlIFhNUCBDb3JlIDUuMy1jMDExIDY2LjE0NTY2MSwgMjAxMi8wMi8wNi0xNDo1NjoyNyAgICAgICAgIj4gPHJkZjpSREYgeG1sbnM6cmRmPSJodHRwOi8vd3d3LnczLm9yZy8xOTk5LzAyLzIyLXJkZi1zeW50YXgtbnMjIj4gPHJkZjpEZXNjcmlwdGlvbiByZGY6YWJvdXQ9IiIgeG1sbnM6eG1wPSJodHRwOi8vbnMuYWRvYmUuY29tL3hhcC8xLjAvIiB4bWxuczp4bXBNTT0iaHR0cDovL25zLmFkb2JlLmNvbS94YXAvMS4wL21tLyIgeG1sbnM6c3RSZWY9Imh0dHA6Ly9ucy5hZG9iZS5jb20veGFwLzEuMC9zVHlwZS9SZXNvdXJjZVJlZiMiIHhtcDpDcmVhdG9yVG9vbD0iQWRvYmUgUGhvdG9zaG9wIENTNiAoV2luZG93cykiIHhtcE1NOkluc3RhbmNlSUQ9InhtcC5paWQ6MkEzNzQwRTBGRjE2MTFFNzgwREI5NDlBQjQzMjYwQUYiIHhtcE1NOkRvY3VtZW50SUQ9InhtcC5kaWQ6MkEzNzQwRTFGRjE2MTFFNzgwREI5NDlBQjQzMjYwQUYiPiA8eG1wTU06RGVyaXZlZEZyb20gc3RSZWY6aW5zdGFuY2VJRD0ieG1wLmlpZDoyQTM3NDBERUZGMTYxMUU3ODBEQjk0OUFCNDMyNjBBRiIgc3RSZWY6ZG9jdW1lbnRJRD0ieG1wLmRpZDoyQTM3NDBERkZGMTYxMUU3ODBEQjk0OUFCNDMyNjBBRiIvPiA8L3JkZjpEZXNjcmlwdGlvbj4gPC9yZGY6UkRGPiA8L3g6eG1wbWV0YT4gPD94cGFja2V0IGVuZD0iciI/PmP1ROAAAAHcSURBVHjaZFJNSxtRFD1vzMeY6IiNVRKkiVSoCN0IEoSCuGnoxm223XQvuGy33fgXuui6u+q2C4UGgghSEfpBsZORYBKpiYkJSSaJr+/e9E0y7YXDu3PuOXfuuzwh29+BVh4c0Q1UnQMEQm1Y8awkqlH6IPruJB4kt326APwhdXJjf+IzaI44FUIn40apuqvO2f9EumZZj6TmDa/QuMR0bBPSLY//XYNrpNHfZJSVkxwXRM9mkHkcnc5X5klDWvIYdJdIYhrd+yp3JOzs7nlNKHdr58yThrTkCfSdL4ilfgHlM5jUy0yi8i2vhGmel3JLzA+HLx/BDCmucAdxtf9CziXOEQz/3VNwic2+6DjDU03Q6/bx++rpaKtEnJ50kX5mswBubGQM3eA418LaetijDCOUQL8S8Yi99zUUyg0WEwpVmzkdpCVPoL24Dcv5zMTauppycQ4f9ydxdlFE9GIKy89TyGTaWI3feWby0KjidvBYmjMTmBUlJahg9SWJ1BbgKlwPry4WUGvG0RkM+HGI5nVx+ADyr3iE6HwNU9Lx7aYpkjAmHqLuXMLaeOczsrl0/BbR+wLCT7Z8xu6PQ7SMFOLp1/j3yWlCDFbeoF7sofrTZlBOnK5r8R8BBgCgreYHPzBRrAAAAABJRU5ErkJggg==) no-repeat;
    width: 14px;
    height: 15px;
    cursor: pointer;
    margin: 0 4px;
  }
  .ico-default-content {
    border: 1px solid #A0A0A0;
    background-color: #F1F1F1;
    position: absolute;
    width: 372px;
    height: 160px;
    overflow-y: scroll;
    left: 0px;
    top: 28px;
    z-index: 2;
  }
  .ico-default-content img {
    display: inline-block;
    cursor: pointer;
    padding: 2px;
  }
  .qu-edit-hf{
    margin-top: 10px;
  }
  .qu-edit-zy {
    margin-top: 6px;
  }
  .qu-edit-zy .el-alert--info {
    background: #fff;
    border: #dcdfe6 solid 1px;
    border-radius: inherit;
    padding: 8px;
  }
  .qu-edit .qu-edit-right{
    width: 20%;
    height: 260px;
    float: right;
    margin: 0 0 0 10px;
    border: 1px solid #CCCCCC;
    overflow-y: scroll;
  }
  .qu-edit .qu-edit-right ul li {
    display: flex;
    display: -webkit-flex;
    -webkit-align-items: center;
    align-items: center;
    padding: 8px;
    border: 1px dashed #ccc;
    border-width: 0 0 1px 0;
    cursor: pointer;
  }
  .qu-edit .qu-edit-right ul li:last-of-type {
    border-bottom: none;
  }
  .qu-edit .qu-edit-right ul li img{
    display: inline-block;
    width: 28px;
    height:28px;
    border-radius: 50%;
    vertical-align: middle;
  }
  .qu-edit .qu-edit-right ul li span {
    display: inline-block;
    margin-left: 10px;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  /* .qu-edit .qu-edit-right ul li.qu-action {
    background-color: #9d1e15;
    color: #ffffff;
  } */
  .qu-list-title {
    font-size: 20px;
    color: #404040;
  }
  .question-right
  .qu-list-search {
    margin-top: 10px;
  }
  .qu-list-search .qu-search-sel1{
    display: block;
  }
  .qu-list-search .qu-search-sel2{
    background: #fff;
  }
  .qu-list-search .el-form-item {
    margin-bottom: 10px;
  }
  .quill-editor {
    height: 100%;
  }
  .qu-highlighted {
    padding: 10px;
    box-shadow: 0px 0px 5px #f00;
  }
  .qu-more {
    display: flex;
    display: -webkit-flex;
    align-items: center;
    -webkit-align-items: center;
    text-align: center;
    margin: 10px auto;
  }
</style>
<style>
  .qu-edit-content .qu-edit-text .el-textarea__inner{
    border: none;
  }
  .qu-list-search .qu-search-sel2 .el-input-group__prepend {
    background-color: #fff;
  }
  .qu-edit-content .qu-edit-text .ql-container{
    height: 136px;
    border: none;
  }
</style>
